import { type ToOptions, useRouter } from '@tanstack/react-router';

/** Steps back through in-app history, or navigates to `fallbackTo` when there is none. */
export const useGoBack = (fallbackTo: ToOptions['to']) => {
  const router = useRouter();

  return () => {
    // __TSR_index is the entry's position in the session history stack: 0 for the first
    // entry (direct link / new tab), > 0 once we've navigated within the app. `key` can't
    // be used here — @tanstack/history writes it on every entry, including the first.
    if (router.history.location.state.__TSR_index > 0) {
      router.history.back();
    } else {
      void router.navigate({ to: fallbackTo });
    }
  };
};
